import { h, Fragment } from "preact";
import { useState, useContext, useRef } from "preact/hooks";

import PropTypes from 'prop-types';

import NumberFormat from 'react-number-format';
import Box from '@mui/material/Box';

import TextField from '@mui/material/TextField';



// const NumberFormatCustom = forwardRef(function NumberFormatCustom(props, ref) {
//     const { onChange, ...other } = props;

//     return (
//         <NumberFormat
//             {...other}
//             getInputRef={ref}
//             onValueChange={(values) => {
//                 onChange({
//                     target: {
//                         name: props.name,
//                         value: values.value,
//                     },
//                 });
//             }}
//             thousandSeparator
//             isNumericString
//             prefix="€"
//         />
//     );
// });
const NumberFormatCustom = (props) => {
    const { onChange, ...other } = props;
    // ref = useRef()
    return (
        <NumberFormat
            {...other}
            //       getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator={" "}
            //  format="### ### ###"
            isNumericString
            suffix=" €"
        />
    );
};
NumberFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default function NumberField(props) {
    //console.log(props)


    return (
        <Box
            sx={{
                '& > :not(style)': {
                    m: 1,
                },
            }}
        >

            <TextField
                variant="outlined"
                style={{
                    marginLeft: 0,
                    marginRight: 10,
                }}
                placeholder={props.placeholder ? props.placeholder : "Prix en euros"}
                fullWidth
                margin="dense"
                size="small"
                disabled={props.disabled ? props.disabled : false}
                value={props.value ? props.value : ''}
                onChange={props.onChange}
                name={props.id}
                id={props.id}
                InputProps={{
                    inputComponent: NumberFormatCustom,
                }}

            />
        </Box>
    );
}
